<template>
  <div class="box6">
    <div class="pagetitle">满足多群体学习需求<br />职业发展路径明确</div>

    <div class="subject-content">
      <div class="topImg"></div>
      <div class="wrap">
        <div class="xian"></div>
        <div class="title">适学人群</div>
        <div class="content">
          <div class="item" v-for="(item, index) in list" :key="index">
            <div class="name">
              <img :src="item.img" alt="" />
              <div class="tit">{{ item.tit }}</div>
            </div>
            <div class="desc">{{ item.txt }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box"></div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      list: [
        {
          img: require("../../../assets/coursePage/java/box6/1.png"),
          tit: "传统行业转行",
          txt: "突破传统行业的职业及薪资瓶颈，转行进入较高收入、较多机会的互联网行业。",
        },
        {
          img: require("../../../assets/coursePage/java/box6/2.png"),
          tit: "快速复业",
          txt: "因疫情或其他原因，之前工作中断，需要寻找新的职业机会，期望快速拿到靠谱offer。",
        },
        {
          img: require("../../../assets/coursePage/java/box6/3.png"),
          tit: "毕业即失业",
          txt: "原有专业就业形式不好，或者对原有专业不是很感兴趣，欲寻找一个靠谱的职业起点。",
        },

        {
          img: require("../../../assets/coursePage/java/box6/4.png"),
          tit: "想系统学习",
          txt: "了解一些计算机或者JavaEE基础知识，想系统的学习AI应用开发语言，为以后求职做准备。",
        },

        {
          img: require("../../../assets/coursePage/java/box6/5.png"),
          tit: "技能提升",
          txt: "想开拓微服务编程技能和优化分布式系统性能，深化编程思想。",
        },
        {
          img: require("../../../assets/coursePage/java/box6/6.png"),
          tit: "跳槽涨薪",
          txt: "突破当前禁锢，技术、项目经验亟需强化、加持，实现身价翻倍。",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box6 {
  padding: 80px 0 88px;
  width: 100%;
  background: linear-gradient(180deg, #466ff1 0%, #5c83fe 100%);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  .pagetitle {
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    text-align: center;
  }
  .subject-content {
    .topImg {
      width: 612px;
      height: 700px;
      margin: 48px auto 80px;
      background: url("../../../assets/coursePage/java/box6/topImg.png")
        no-repeat;
      background-size: cover;
    }
    .wrap {
      width: 686px;
      height: 984px;
      background: #ffffff;
      box-shadow: 0px 8px 24px 0px rgba(12, 158, 123, 0.12);
      border-radius: 20px;
      border: 1px solid #ffffff;
      position: relative;
      box-sizing: border-box;
      .xian {
        background: url("../../../assets/coursePage/java/box6/cneterbgc.png")
          no-repeat;
        width: 626px;
        background-size: cover;
        height: 782px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 120px;
      }
      .title {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 44px;
        margin: 48px 0 32px;
        text-align: center;
      }
      .content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item {
          width: 340px;
          padding: 0 36px;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          margin-bottom: 96px;
          flex-wrap: wrap;
          .name {
            display: flex;
            align-items: center;
            img {
              margin-right: 8px;
              width: 44px;
              height: 44px;
            }
            .tit {
              font-size: 28px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #004de8;
              line-height: 44px;
            }
          }
          .desc {
            margin-top: 16px;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #1d2129;
            line-height: 40px;
            text-align: center;
          }
        }
        .item:nth-child(5),
        .item:nth-child(6) {
          margin-bottom: 48px;
        }
      }
    }
  }
  .box {
    width: 200px;

    border-top: 2px dashed #ff5d3e;
    box-sizing: border-box;
  }

  @supports (-webkit-mask: none) or (mask: none) {
    .box {
      border: none;
      background: linear-gradient(to bottom, #ff1481, #ff5d3e) no-repeat;
      -webkit-mask-image: linear-gradient(to right, #000 6px, transparent 6px),
        linear-gradient(to bottom, #000 6px, transparent 6px),
        linear-gradient(to right, #000 6px, transparent 6px),
        linear-gradient(to bottom, #000 6px, transparent 6px);
      -webkit-mask-repeat: repeat-x, repeat-y, repeat-x, repeat-y;
      -webkit-mask-position: 0 0, 0 0, 0 100%, 100% 0;
      -webkit-mask-size: 8px 2px, 2px 8px, 8px 2px, 2px 8px;

      /* 合并写法 */
      mask: linear-gradient(to right, #000 6px, transparent 6px) repeat-x,
        linear-gradient(to bottom, #000 6px, transparent 6px) repeat-y,
        linear-gradient(to right, #000 6px, transparent 6px) repeat-x 0 100%,
        linear-gradient(to bottom, #000 6px, transparent 6px) repeat-y 100% 0;
      mask-size: 8px 2px, 2px 8px, 8px 2px, 2px 8px;
    }
  }
}
</style>
